export default defineNuxtPlugin({
  name: 'auth',
  enforce: 'pre', // as early as possible but depends on pinia
  dependsOn: [
    // Note: pinia does not run as pre so we should have plugins depend on 'auth' if they need the authenticated user
    'pinia',
  ],
  async setup() {
    const auth = useAuth()
    // This ensures that the auth state is ready before the app starts and we won't have race conditions
    // with middlewares, etc.
    await auth.waitForAuth({ from: 'auth plugin' })
  },
})
